var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.changeLocale}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" language ")]),_vm._v(" "+_vm._s(_vm.switchLabel)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }